// extracted by mini-css-extract-plugin
export default {"box":"index_box__P-IQJ","big_title":"index_big_title__MgjG-","cont":"index_cont__oWN3Z","item":"index_item__Klo1x","time":"index_time__DmQOK","title":"index_title__ivy+1"};